import { useParams } from 'react-router-dom';
import { Layout } from 'features/Layouts/Layouts';
import { WorkerContent } from 'components/WorkerContent';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { useGetEmployedQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { ResponseEmployedType } from 'redux/Api/employedsWorkSupportApi/type';

export const EmployedsDetails = () => {
  const { id = 0 } = useParams();
  const { data, isLoading } = useGetEmployedQuery({ id: Number(id) });

  return (
    <Layout>
      {isLoading ? (
        <LoadingSkeleton mt />
      ) : (
        <WorkerContent
          workerId={id}
          data={
            data ? (data as ResponseEmployedType & Record<string, unknown>) : undefined
          }
        />
      )}
    </Layout>
  );
};
